const BULGARIA_COUNTRY_CODE = 'BG';
const ENHANCED_KYC_MIN_AGE = 60;

function normalizeCountryCode(value) {
  return String(value || '')
    .trim()
    .toUpperCase();
}

function normalizeCountryList(value) {
  if (Array.isArray(value)) return value.map(normalizeCountryCode).filter(Boolean);
  if (typeof value === 'string') {
    return value
      .split(',')
      .map(normalizeCountryCode)
      .filter(Boolean);
  }
  return [];
}

function getBirthDate(user) {
  return user?.userDetails?.birthDate ?? user?.userDetails?.BirthDate ?? user?.birthDate ?? null;
}

function getAddressCountry(user) {
  const address = user?.userDetails?.address ?? user?.userDetails?.Address ?? null;
  return normalizeCountryCode(address?.country ?? address?.Country);
}

function getProfileCountryCodes(user) {
  const profile = user?.userDetails?.onboardingProfile ?? user?.userDetails?.OnboardingProfile ?? {};
  const otherCitizenships = normalizeCountryList(profile.otherCitizenships ?? profile.OtherCitizenships);
  const destinationCountries = normalizeCountryList(profile.destinationCountries ?? profile.DestinationCountries);
  return [...otherCitizenships, ...destinationCountries];
}

export function getIndividualAgeYears(user, now = new Date()) {
  const raw = getBirthDate(user);
  if (!raw) return null;

  const birthDate = new Date(raw);
  if (Number.isNaN(birthDate.getTime())) return null;

  let age = now.getFullYear() - birthDate.getFullYear();
  const monthDiff = now.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
}

export function isBulgariaTriggered(user, extraCountryCodes = []) {
  const addressCountry = getAddressCountry(user);
  if (addressCountry === BULGARIA_COUNTRY_CODE) return true;

  const codes = [...getProfileCountryCodes(user), ...extraCountryCodes.map(normalizeCountryCode)];
  return codes.includes(BULGARIA_COUNTRY_CODE);
}

/** Enhanced individual KYC: age 60+ or Bulgaria (residence / destinations / citizenships). */
export function requiresEnhancedIndividualKyc(user, { extraCountryCodes = [], now = new Date() } = {}) {
  const age = getIndividualAgeYears(user, now);
  if (typeof age === 'number' && age >= ENHANCED_KYC_MIN_AGE) return true;
  return isBulgariaTriggered(user, extraCountryCodes);
}

export function isLowRiskIndividualKyc(user, options) {
  return !requiresEnhancedIndividualKyc(user, options);
}
